/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPasswordReqVo
 */
export interface UserPasswordReqVo {
    /**
     * 新密码
     * @type {string}
     * @memberof UserPasswordReqVo
     */
    newPassword?: string;
    /**
     * 短信验证码
     * @type {string}
     * @memberof UserPasswordReqVo
     */
    verifyCode?: string;
}

/**
 * Check if a given object implements the UserPasswordReqVo interface.
 */
export function instanceOfUserPasswordReqVo(value: object): value is UserPasswordReqVo {
    return true;
}

export function UserPasswordReqVoFromJSON(json: any): UserPasswordReqVo {
    return UserPasswordReqVoFromJSONTyped(json, false);
}

export function UserPasswordReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPasswordReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
        'verifyCode': json['verifyCode'] == null ? undefined : json['verifyCode'],
    };
}

export function UserPasswordReqVoToJSON(json: any): UserPasswordReqVo {
    return UserPasswordReqVoToJSONTyped(json, false);
}

export function UserPasswordReqVoToJSONTyped(value?: UserPasswordReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newPassword': value['newPassword'],
        'verifyCode': value['verifyCode'],
    };
}

